module.exports = __webpack_public_path__ + "static/media/outline-icons.b551b554.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/semantic/themes/default/assets/fonts/outline-icons.svg
// module id = 4411
// module chunks = 0